module.exports = __webpack_public_path__ + "static/Guestonline-a955a728cc402a01aa080d6c2fe54cbc.svg";